import { render, staticRenderFns } from "./GoodsSummary.vue?vue&type=template&id=0d700631"
import script from "./GoodsSummary.vue?vue&type=script&lang=js"
export * from "./GoodsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports